import { render, staticRenderFns } from "./VConfirmDialog.vue?vue&type=template&id=4eab831c"
import script from "./VConfirmDialog.vue?vue&type=script&lang=js"
export * from "./VConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports